import { useModel } from '@umijs/max';
import styles from './index.less';

const CustomerDefaultInformation = () => {
  const { ownerInformation, defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation,
      defaultRoom: model.defaultRoom,
    }),
  );

  return (
    <div className={styles.container}>
      <p>用户名称：{ownerInformation?.nickName}</p>
      <p>当前房屋：{defaultRoom?.roomCode}</p>
    </div>
  );
};

export default CustomerDefaultInformation;
